<template>
  <div class="uk-text-left uk-padding-remove">
    <div
      class="uk-card uk-card-body main"
    >
      <h4
        class="title"
      >
        Descripción
      </h4>
      <p
        v-if="!messageInformation.message"
        class="helper"
      >
        Coloque el mouse sobre el elemento deseado, para ver la descripción.
      </p>
      <img
        v-if="messageInformation.image"
        :src="require(`../../assets/img/costs/${messageInformation.image}`)"
      >
      <p class="helper">
        {{ messageInformation.message }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters([
      'messageInformation'
    ])
  }
}

</script>

<style scoped>
.main{
  padding: 20px 15px;
  text-align: center;
}
.helper{
  color:rgb(119 118 118 / 58%) !important;
  text-align: left;
}
.title{
  margin: 0px;
  font-weight:600;
}

</style>
